<template>
  <div class="dk-page-wrap">

    <!-- Painel Esquerdo -->
    <div class="dk-sidebar-panel">
      <div class="dk-panel-header">
        <div class="dk-icon-wrap" style="background: rgba(245,185,53,0.12);">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" stroke="#F5B935" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>
        <div>
          <div class="dk-panel-title">Progresso Inteligente</div>
          <div class="dk-panel-sub">Estilo da barra de progresso</div>
        </div>
      </div>

      <div class="dk-panel-actions">
        <button class="dk-btn-primary" @click="updateSubmit()">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" stroke="#fff" stroke-width="2"/><path d="M17 21v-8H7v8M7 3v5h8" stroke="#fff" stroke-width="2"/></svg>
          Salvar
        </button>
        <router-link :to="`/player/${vslId}/customizacao`" class="dk-btn-ghost">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M19 12H5M12 19l-7-7 7-7" stroke="#64748b" stroke-width="2" stroke-linecap="round"/></svg>
          Voltar
        </router-link>
      </div>

      <div class="dk-panel-body" v-if="bar && bar[0]">
        <!-- Altura da barra -->
        <div class="dk-section-title">Altura da Barra</div>
        <div class="dk-slider-group">
          <div class="dk-slider-header">
            <span class="dk-slider-value">{{ bar[0].bar_hight }}px</span>
          </div>
          <input
            v-model="bar[0].bar_hight"
            type="range"
            class="dk-range-slider"
            min="1"
            max="15"
          >
          <div class="dk-slider-track-labels">
            <span>1px</span>
            <span>15px</span>
          </div>
        </div>

        <div class="dk-divider" />

        <!-- Cor da barra -->
        <div class="dk-section-title">Cor da Barra</div>
        <div class="dk-color-row">
          <span class="dk-color-label">Selecionar cor</span>
          <div class="dk-color-pick">
            <input v-model="bar[0].bar_cor" type="color" class="dk-color-input">
            <span class="dk-color-hex">{{ bar[0].bar_cor }}</span>
          </div>
        </div>

        <div class="dk-divider" />

        <!-- Live preview da barra -->
        <div class="dk-barra-preview-label">Preview da barra</div>
        <div class="dk-barra-preview-track">
          <div
            class="dk-barra-preview-fill"
            :style="'height:' + bar[0].bar_hight + 'px; background-color:' + bar[0].bar_cor + '; width:55%;'"
          />
        </div>
      </div>
    </div>

    <!-- Player Preview -->
    <div class="dk-player-area">
      <div class="dk-player-label">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#E86A10" stroke-width="2"/><path d="M10 8l6 4-6 4V8z" fill="#E86A10"/></svg>
        Preview do Player
      </div>
      <player-preview-iframe
        :vsl-id="vslId"
        :thumb-src="dadosVideo && dadosVideo.thumb ? dadosVideo.thumb.thumbStart : ''"
        :orientation="dadosVideo && dadosVideo.orientation ? dadosVideo.orientation : 'Horizontal'"
      />
    </div>

  </div>
</template>

<script>


import Detalhes from '../../EditarVideo/Detalhes.vue';
import { BarsService } from '@/services/Bar';
import { ControlsService } from '@/services/Controls';
import PlayerPreviewIframe from '@/components/player/PlayerPreviewIframe.vue'
export default {
  components: {
    Detalhes,
    PlayerPreviewIframe,

  },
  data: function () {
    return {
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend',
      vslId: this.$route.params.vslId,
      loading: false,
      bar: {
        bar_cor: '',
        bar_hight: '',
        id_vsl: '',
      },
      errorMessage: null,
      control: [],
      dadosVideo: [],

    }
  },
  created: async function () {
    try {
      this.loading = true;

      this.loading = false;
    }
    catch (error) {
      this.errorMessage = error;
      this.loading = false;

    }
  },
  created: async function () {
    try {
      this.loading = true;
      let bar = await BarsService.getBarsVSL_Id(this.vslId)
      this.bar = bar.data;
      let response = await ControlsService.getControlVSL_Id(this.vslId)
      console.log(this.vslId);
      this.control = response.data;
      this.loading = false;
    } catch (error) {
      this.errorMessage = error;
      this.loading = false;

    }
  },
  computed: {
    getControls() {
      console.log("oi")
      return this.control
    }
  },
  beforeMount() {
    this.jsonPersonalizado();

  },
  methods: {
    jsonPersonalizado() {

      const url = `${this.VUE_APP_HOST_API_BACKEND}/vslsInner/` + this.vslId;
      fetch(url)
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log(data.status)
          if (data.status == "1") {
            this.dadosVideo = data.json.find(item => String(item.id) === String(this.vslId))
          }

        });
    },
    updateSubmit() {
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/bar/` + this.vslId, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: '{"bar_cor":"' + this.bar[0].bar_cor +
          '","bar_hight":"' + this.bar[0].bar_hight +
          '","id_vsl":"' + this.vslId + '"}'
      })

        .then(response => {
          this.$message({
            type: 'success',
            message: 'Salvo com sucesso'
          });

        })

        .catch(err => console.error(err));
    },
  }



}

</script>
<style scoped>
.tb {
  display: inline-block;
  width: 30px;
  height: 30px;
  margin: 0px;
  border: none;
}

.player {
  max-width: 875px;
  /* //border: 4px solid rgba(0,0,0,.2);
 //box-shadow: 0 0 20px rgba(0,0,0,.2); */
  position: relative;
  font-size: 20;
  overflow: hidden;
}

.player {
  width: 100%;
}

.player:fullcreen {
  max-width: none;
  width: 100%;
}


.player:-webkit-full-screen {
  max-width: none;
  width: 100%;
}

.player:-ms-full-screen {
  max-width: none;
  width: 100%;
}

.player:-moz-full-screen {
  max-width: none;
  width: 100%;
}

.player_my_video {
  min-width: 102%;
    height: 500px;

}

.player_my_controls {
  display: flex;
  position: absolute;
  bottom: 0;
  width: 100%;
  transform: translateY(100%) translateY(-31%);
  transition: all .3s;
  flex-wrap: wrap;
  background: rgba(0, 0, 0, .2);
}

.progress_my_filled {
  width: 80%;
  /* //background: #ffc600; */

  flex: 0;
  flex-basis: 0%;
}

.player:hover .player_my_controls {
  transform: translateY(0);
}

.player_my_controls>* {
  flex: 1;
}

.progress {
  flex: 10;
  position: relative;
  display: flex;
  flex-basis: 100%;

  transition: height .3s;
  background: rgba(0, 0, 0, .25);
  cursor: pointer;
  /* ew-resize*/
}

.player_my_button {
  background: none;
  border: 0;
  line-height: 1;
  color: white;
  text-align: center;
  outline: 0;
  padding: 10px 15px 10px 15px;
  cursor: pointer;
  max-width: 50px;

}

.playerSlider {
  display: block;
  width: 10px;
  height: 30px;
}

input[type=range] {
  -webkit-appearance: none !important;
  background: transparent;
  width: 100%;
  margin: 0 5px;
}

input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: 2px;
  cursor: pointer;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0 0 1px rgba(13, 13, 13, 0);
  background: rgba(255, 255, 255, .8);
  border-radius: 1.3px;
  border: 0.2px solid rgba(1, 1, 1, 0)
}

input[type=range]::-webkit-slider-thumb {
  height: 10px;
  width: 10px;
  border-radius: 50px;
  background: var(--dk-bg-card, #fff);
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -4px;
  box-shadow: 0 0 2px rgba(0, 0, 0, .2);
}

input[type=range]:focus {
  outline: none;

}

input[type=range]:focus::-webkit-slider-runnable-track {
  background: #ff0;

}

/* Mozila Linha do volume*/

input[type=range]::-moz-range-track {
  width: 100%;
  height: 0.1px;
  cursor: pointer;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0 0 1px rgba(13, 13, 13, 0);
  background: var(--dk-bg-card, #fff);
  border-radius: 1.3px;
  border: 0.2px solid rgba(1, 1, 1, 0)
}

/* Mozila Circulo do volume*/

input[type=range]::-moz-range-thumb {
  height: 10px;
  width: 10px;
  border-radius: 50px;
  border-color: none;
  background: var(--dk-bg-card, #fff);
  cursor: pointer;
}

.fullscreenbtn {

margin-left: 75%;
border: 0;
line-height: 1;
color: white;
text-align: center;
align-content: stretch;
outline: 0;
cursor: pointer;
max-width: 4px;
}

.button_volume {

margin-left: -2%;
border: 0;
line-height: 1;
color: white;
text-align: center;
align-content: stretch;
outline: 0;
cursor: pointer;
max-width: 4px;
}

.PictureInPicture {
margin-left: -9%;
border: 0;
line-height: 1;
color: white;
text-align: center;
align-content: stretch;
outline: 0;
cursor: pointer;
max-width: 4px;
}


.playpause {

  border-radius: 50px;
  background-image: url(../img/play.svg);
  background-repeat: no-repeat;
  width: 100px;
  height: 100px;
  position: absolute;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
  margin: auto;
  background-size: contain;
  background-position: center;
  cursor: pointer;
  z-index: 10 !important;
}

.playpause {
  opacity: 1;
  transition: opacity 400ms;
}

.playpause[hidden] {
  opacity: 0;

}

.iniciar {
  border: 2px solid;
  border-style: none;
  border-radius: 15px 50px;
  display: block;
  width: 50%;
  height: 50%;
  position: absolute;
  flex-direction: column-reverse;
  display: flex;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
  margin: auto;
  align-items: center;
  background-size: contain;
  background-position: center;

}

.video-banner {
  position: relative;
}

.video-banner .overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  z-index: 1;
}

.loader {
  height: 70px;
  width: 200px;
  display: flex;
  align-items: center;
}

.loader .stroke {
  display: block;
  position: relative;
  background: var(--dk-bg-inset, #f1f1f1);
  height: 50%;
  width: 15%;
  border-radius: 50px;
  margin: 0 5px;
  align-items: center;
  animation: animate 1.2s linear infinite;
}

/* .playImagem {
    width: 64px;
    height: 64px;
    cursor: pointer;
  } */


h2 {
  position: relative;
  align-self: center;
  font-family: Arial, Helvetica, sans-serif;
}

@keyframes animate {
  50% {
    height: 20%;
  }

  100% {
    height: 100%;
  }
}

.stroke:nth-child(1) {
  animation-delay: 0s;
}

.stroke:nth-child(2) {
  animation-delay: 0.3s;
}

.stroke:nth-child(3) {
  animation-delay: 0.6s;
}

.stroke:nth-child(4) {
  animation-delay: 0.9s;
}

.stroke:nth-child(5) {
  animation-delay: 0.6s;
}

.stroke:nth-child(6) {
  animation-delay: 0;
}

.stroke:nth-child(7) {
  animation-delay: 0.2s;
}

.stroke:nth-child(8) {
  animation-delay: 0.5s;
}

.stroke:nth-child(9) {
  animation-delay: 0.1s;
}

.stroke:nth-child(10) {
  animation-delay: 0s;
}

.stroke:nth-child(11) {
  animation-delay: 0.3s;
}

.stroke:nth-child(12) {
  animation-delay: 0.6s;
}

.stroke:nth-child(13) {
  animation-delay: 0.3s;
}

#context-menu {
  position: fixed;
  width: 170px;
  height: 20px;
  border: #000;
  background: rgba(40, 38, 38, 0.856);
  transform: scale(0);
  transform-origin: top left;
  padding: 8px 8px 8px 8px;
}

#context-menu.active {
  transform: scale(1);
  transition: transform 200ms ease-in-out;
}

#context-menu a {
  font-size: 15px;
  font-family: Arial, Helvetica, sans-serif;
  color: #eee;
  text-decoration: none;
}

#context-menu .item:hover {
  background: #555;
}

.playpausebg {

  background-repeat: no-repeat;
  width: 102%;
  height: 128%;
  position: absolute;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
  margin: auto;
  background-size: contain;
  background-position: center;
  cursor: pointer;
  z-index: 2 !important;
}

.playpausebg {
  opacity: 1;
  transition: opacity 400ms;
}

.playpausebg[hidden] {
  opacity: 0;

}

.playEndedbg {

  background-repeat: no-repeat;
  width: 102%;
  height: 128%;
  position: absolute;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
  margin: auto;
  background-size: contain;
  background-position: center;
  cursor: pointer;
  z-index: 2 !important;
}

.playEndedbg {
  opacity: 1;
  transition: opacity 400ms;
}

.playEndedbg[hidden] {
  opacity: 0;
}

/* ===================== DK BRAND STYLES ===================== */
.dk-page-wrap {
  display: flex; flex-direction: row;
  min-height: calc(100vh - 80px);
  background: var(--dk-bg-segment, #F4F6F9);
  --dk-bg-segment:     rgba(255,255,255,0.04);
  --dk-bg-card:        rgba(255,255,255,0.05);
  --dk-bg-page:        rgba(255,255,255,0.04);
  --dk-border:         rgba(255,255,255,0.09);
  --dk-border-light:   rgba(255,255,255,0.07);
  --dk-text-primary:   #e2e8f0;
  --dk-text-secondary: rgba(255,255,255,0.6);
  --dk-text-muted:     rgba(255,255,255,0.4);
  --dk-text-faint:     rgba(255,255,255,0.25);
}
.dk-sidebar-panel {
  width: 300px; min-width: 280px; max-width: 310px;
  background: var(--dk-bg-card, #fff);
  border-right: 1px solid var(--dk-border, #DDE3EA);
  display: flex; flex-direction: column;
  overflow-y: auto;
}
.dk-panel-header {
  display: flex; align-items: center; gap: 12px;
  padding: 24px 20px 16px;
  border-bottom: 1px solid var(--dk-border-light, #F0F2F5);
}
.dk-icon-wrap {
  width: 40px; height: 40px; border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.dk-panel-title { font-size: 15px; font-weight: 700; color: var(--dk-text-primary, #0D3349); line-height: 1.2; }
.dk-panel-sub { font-size: 11px; color: var(--dk-text-muted, #94a3b8); margin-top: 2px; }
.dk-panel-actions {
  display: flex; gap: 8px; padding: 14px 20px;
  border-bottom: 1px solid var(--dk-border-light, #F0F2F5);
}
.dk-panel-body { padding: 20px; flex: 1; overflow-y: auto; }
.dk-btn-primary {
  display: inline-flex; align-items: center; gap: 6px;
  background: #E86A10 !important; background-image: none !important;
  color: #fff !important; border: none; border-radius: 8px;
  padding: 9px 18px; font-size: 13px; font-weight: 600;
  cursor: pointer; box-shadow: 0 2px 8px rgba(232,106,16,0.25);
  transition: background 0.18s;
}
.dk-btn-primary:hover { background: #cf5c07 !important; }
.dk-btn-ghost {
  display: inline-flex; align-items: center; gap: 6px;
  background: var(--dk-bg-segment, #F4F6F9) !important; background-image: none !important;
  color: var(--dk-text-secondary, #64748b) !important; border: 1px solid rgba(255,255,255,0.09);
  border-radius: 8px; padding: 9px 16px; font-size: 13px;
  font-weight: 500; cursor: pointer; text-decoration: none;
}
.dk-btn-ghost:hover { background: rgba(255,255,255,0.08) !important; color: #e2e8f0 !important; text-decoration: none; }
.dk-section-title {
  font-size: 11px; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.08em; color: var(--dk-text-muted, #94a3b8); margin-bottom: 10px;
}
.dk-divider { border-top: 1px solid var(--dk-border-light, #F0F2F5); margin: 16px 0; }
.dk-color-row {
  display: flex; align-items: center; justify-content: space-between;
  padding: 10px 12px; background: var(--dk-bg-page, #F8FAFB); border: 1px solid rgba(255,255,255,0.09);
  border-radius: 8px; margin-bottom: 10px;
}
.dk-color-label { font-size: 12px; color: var(--dk-text-secondary, #64748b); font-weight: 500; }
.dk-color-pick { display: flex; align-items: center; gap: 8px; }
.dk-color-input {
  width: 32px; height: 32px; border: none; padding: 0;
  border-radius: 6px; cursor: pointer; overflow: hidden;
}
.dk-color-hex { font-size: 11px; font-family: monospace; color: var(--dk-text-secondary, #64748b); }
.dk-slider-group { margin-bottom: 4px; }
.dk-slider-header { display: flex; justify-content: flex-end; margin-bottom: 4px; }
.dk-slider-value {
  font-size: 13px; font-weight: 700; color: #E86A10;
  background: rgba(232,106,16,0.08); padding: 2px 8px; border-radius: 20px;
}
.dk-range-slider {
  width: 100%; -webkit-appearance: none;
  height: 4px; border-radius: 4px; background: rgba(255,255,255,0.15); outline: none; cursor: pointer;
}
.dk-range-slider::-webkit-slider-thumb {
  -webkit-appearance: none; width: 18px; height: 18px;
  border-radius: 50%; background: #E86A10;
  box-shadow: 0 2px 6px rgba(232,106,16,0.3); cursor: pointer;
}
.dk-slider-track-labels {
  display: flex; justify-content: space-between;
  font-size: 10px; color: var(--dk-text-muted, #94a3b8); margin-top: 4px;
}
.dk-barra-preview-label { font-size: 11px; color: var(--dk-text-muted, #94a3b8); margin-bottom: 8px; font-weight: 600; }
.dk-barra-preview-track {
  background: rgba(255,255,255,0.12); border-radius: 8px; overflow: hidden;
  height: 20px; /* variable in template */
}
.dk-barra-preview-fill { border-radius: 8px; transition: all 0.2s; }
.dk-player-area {
  flex: 1; display: flex; flex-direction: column;
  padding: 32px 40px; background: var(--dk-bg-segment, #F4F6F9); min-width: 0;
}
.dk-player-label {
  display: flex; align-items: center; gap: 6px;
  font-size: 11px; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.08em; color: var(--dk-text-muted, #94a3b8); margin-bottom: 14px;
}
.dk-player {
  background: #0a1520; border-radius: 14px; overflow: hidden;
  box-shadow: 0 8px 32px rgba(13,51,73,0.18);
  max-width: 880px; width: 100%; aspect-ratio: 16/9; position: relative;
}
</style>
